import React, { useContext } from "react";
import { formatStringWithPlaceholders } from "../../../../helpers/Utils";
import { GiftCardSendTypeEnum } from "../../../../models/enums/GiftCardSendTypeEnum";
import { AppSettingContext } from "../../../Application";

interface ISummarySectionProps {
    cardsQuantity: number;
    cardsValue: number;
    recipientsCount: number;
    sendBy?: GiftCardSendTypeEnum;
}

const SummarySection = (props: ISummarySectionProps) => {
    const { labels } = useContext(AppSettingContext);

    return (
        <>
            <div className="summary-box box">
                <div className="action-card">
                    <h4 className="box-heading">
                        <i className="box-icon">
                            <img src="/static/options-card-page/options-card-icon-04.png" alt="icon 04" />
                        </i>
                        {labels.get("GiftCard.App.V2.Sidebar.Summary.Title")}
                    </h4>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    {formatStringWithPlaceholders(labels.get("GiftCard.App.V2.Sidebar.Summary.Quantity"), props.cardsQuantity.toString())}
                                </td>
                                <td>
                                    &euro;{formatStringWithPlaceholders(labels.get("GiftCard.App.V2.Sidebar.Summary.Value"), props.cardsValue.toString())}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {formatStringWithPlaceholders(labels.get("GiftCard.App.V2.Sidebar.Summary.Recipients"), props.recipientsCount.toString())}
                                </td>
                                <td>
                                    {props.sendBy === GiftCardSendTypeEnum.BY_EMAIL ? "Email"
                                        : props.sendBy === GiftCardSendTypeEnum.BY_SMS ? "SMS" : "PDF"}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>{labels.get("GiftCard.App.V2.Sidebar.Summary.LabelTotal")}</td>
                                <td>&euro;{props.cardsQuantity * props.cardsValue}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </>
    );
};

export default SummarySection;